import { useState, useEffect } from 'react'
import { useAuth } from '@/hooks/use-auth'
import { Navigate, Outlet } from 'react-router-dom'
import { Skeleton } from '@/components/ui/skeleton'
import { getSubscription } from '@/services/subscription'

export const ProtectedRoute = () => {
  const { user, loading: authLoading } = useAuth()
  const [subscription, setSubscription] = useState<any>(null)
  const [isCheckingSubscription, setIsCheckingSubscription] = useState(true)

  useEffect(() => {
    if (authLoading) {
      return
    }
    if (user) {
      getSubscription()
        .then(setSubscription)
        .finally(() => setIsCheckingSubscription(false))
    } else {
      setIsCheckingSubscription(false)
    }
  }, [user, authLoading])

  if (authLoading || isCheckingSubscription) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen p-4">
        <div className="w-full max-w-md space-y-8">
          <Skeleton className="h-10 w-3/4" />
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-12 w-full mt-4" />
        </div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  if (!subscription) {
    return <Navigate to="/subscribe" replace />
  }

  return <Outlet />
}
